import React from "react"
import { Spacer } from "components/views/atoms/Atoms"
import { H2, Body, FlexContainer } from "@carrotfertility/carotene"
import { Button, Stack } from "@carrotfertility/carotene-core"
import { IlloCoinsAndBills } from "components/views/atoms/Illustrations"
import { useReimbursementContext } from "components/context/reimbursement/GetReimbursedContext"
import { FormattedMessage } from "react-intl"

export function GetReimbursedFinalStep(): JSX.Element {
  const { onExit } = useReimbursementContext()

  return (
    <>
      <Spacer height={2} />
      <FlexContainer justifyContent="center" padding="none" stack="large">
        <IlloCoinsAndBills />
      </FlexContainer>
      <Stack>
        <H2 stack="small" variant="primary">
          <FormattedMessage defaultMessage="You're all set" />
        </H2>
        <Body color="black-80">
          <FormattedMessage defaultMessage="We've received your reimbursement request and will review it as soon as possible. We'll notify you when it's approved or if we need any additional information." />
        </Body>
      </Stack>
      <FlexContainer justifyContent="center" paddingTopBottom="huge">
        <Button variant="contained" color="primary" size="medium" onClick={onExit}>
          <FormattedMessage defaultMessage="Close" />
        </Button>
      </FlexContainer>
    </>
  )
}
